function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
export var Close = function Close(props) {
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    fill: "#FDF3F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1661 9.54105C15.3613 9.34579 15.3613 9.02921 15.1661 8.83395C14.9708 8.63868 14.6542 8.63868 14.4589 8.83395L12 11.2929L9.54105 8.83395C9.34579 8.63868 9.02921 8.63868 8.83395 8.83395C8.63868 9.02921 8.63868 9.34579 8.83395 9.54105L11.2929 12L8.83395 14.4589C8.63868 14.6542 8.63868 14.9708 8.83395 15.1661C9.02921 15.3613 9.34579 15.3613 9.54105 15.1661L12 12.7071L14.4589 15.1661C14.6542 15.3613 14.9708 15.3613 15.1661 15.1661C15.3613 14.9708 15.3613 14.6542 15.1661 14.4589L12.7071 12L15.1661 9.54105Z",
    fill: "#EF4550"
  }));
};